var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .688A7.312 7.312 0 1015.313 8 7.32 7.32 0 008 .688zm3.938 7.875H8A.562.562 0 017.437 8V4.063a.563.563 0 011.125 0v3.375h3.376a.563.563 0 010 1.125z",
    fill: "inherit"
  })));
}

export default SvgTimer;